export const ALL_MY_NOTIFICATIONS = {
  PAGE: (pageNumber) => `notifications/all?page=${pageNumber}`,
};
export const UNREAD_NOTIFICATIONS = {
  PAGE: (pageNumber) => `notifications/unread?page=${pageNumber}`,
};
export const MARK_NOTIFICATION_AS_READ = `notifications/mark-as-read`;
export const DELETE_NOTIFICATION = `notifications/delete`;
